import { Moment } from 'moment';
import { ProfileMapper } from '../../../common/mappers/ProfileMapper';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Project } from '../models/Project';
import { IssueStatistics } from '../models/valueObjects/IssueStatistics';

export class ProjectMapper {
  private readonly encoder = new GQLIdEncoder();
  private readonly profileMapper = new ProfileMapper();

  mapToDomain(data: any): Project {
    const id = this.encoder.decode(data.id);

    const issueStatistics = this.extractIssueStats(data.vulnerabilityStatistics || []);
    const profile = data.defaultProfile ? this.profileMapper.mapGQLModel(data.defaultProfile) : null;

    let lastAnalysis: Moment | null = null;
    if (data.lastAnalysis) {
      lastAnalysis = DateUtils.toMoment(data.lastAnalysis);
    }

    return new Project(id, data.id, data.name, issueStatistics, lastAnalysis, profile, data.description, data.maxItemCount);
  }

  private extractIssueStats(data: any[]): IssueStatistics {
    const issueStats = {
      high: 0,
      low: 0,
      med: 0,
      noWarning: 0,
    };

    for (const issue of data) {
      const amount = issue.amount ?? 0;
      switch (issue.severity) {
        case 'HIGH':
          issueStats.high = amount;
          break;
        case 'MEDIUM':
          issueStats.med = amount;
          break;
        case 'LOW':
          issueStats.low = amount;
          break;
        case 'PASSED':
          issueStats.noWarning = amount;
          break;
        default:
        // just skip, do nothing
      }
    }

    return new IssueStatistics(issueStats.high, issueStats.med, issueStats.low, issueStats.noWarning);
  }
}
